import { render, staticRenderFns } from "./tabCard.vue?vue&type=template&id=7f5c2b31&scoped=true"
import script from "./tabCard.vue?vue&type=script&lang=js"
export * from "./tabCard.vue?vue&type=script&lang=js"
import style0 from "./tabCard.vue?vue&type=style&index=0&id=7f5c2b31&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5c2b31",
  null
  
)

export default component.exports